<div hlmSidebarWrapper class="h-screen">
  <!-- Sidebar navigation -->
  <app-sidebar />

  <!-- Main content area -->
  <main hlmSidebarInset class="h-screen overflow-hidden">
    <div class="h-full overflow-y-auto p-6">
      <router-outlet />
    </div>
  </main>
</div>
